import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var VenderVehicleDetailsRes;
export const VenderVehicleDetailsTodo = createAsyncThunk('VenderVehicleDetails', async (id) => {
    try {
        const res = await axios({
            method: "Get",
            url: process.env.REACT_APP_API_URL + `ven_vehicle_data/${id}`,
           
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return VenderVehicleDetailsRes = res.data

    } catch (error) {
        return VenderVehicleDetailsRes = error.response.data
    }
})

const VenderVehicleDetailsSlice = createSlice({
    name: 'VenderVehicleDetails',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(VenderVehicleDetailsTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('equipmentList', state.data.response)
        });
        builder.addCase(VenderVehicleDetailsTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default VenderVehicleDetailsSlice.reducer; 